export default __webpack_public_path__ + "media/components/ParallaxCrayon/crayon_4-e85356bdc501eb29b2889194865af32d.png";